import Footer from 'components/footer/Footer';

export default Footer;
